import { useEffect } from "react";
import "@/App.css";
import "@/editorial.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Shell from "@/components/Shell";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Aky from "@/pages/Aky";
import LeadAi from "@/pages/LeadAi";
import Research from "@/pages/Research";
import ResearchNote from "@/pages/ResearchNote";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/aky" element={<Aky />} />
          <Route path="/lead-ai" element={<LeadAi />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/:slug" element={<ResearchNote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}

export default App;
